var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFillStar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.60374 10.1575C6.44446 10.0609 6.24472 10.0609 6.08544 10.1575L2.98335 12.0375C2.60472 12.267 2.13667 11.9275 2.23727 11.4963L3.05956 7.97222C3.10164 7.79191 3.04062 7.6031 2.90097 7.48151L0.171735 5.10519C-0.161363 4.81517 0.0176534 4.26729 0.457733 4.22989L4.05502 3.92424C4.23953 3.90856 4.40026 3.7922 4.47276 3.62181L5.88451 0.304211C6.05712 -0.101419 6.63206 -0.101419 6.80467 0.304211L8.21634 3.62164C8.28888 3.79212 8.44974 3.90851 8.63436 3.92409L12.2566 4.22987C12.6979 4.26712 12.8765 4.81722 12.5413 5.10658L9.79014 7.48153C9.6494 7.60302 9.58769 7.79257 9.62994 7.97363L10.4519 11.4963C10.5525 11.9275 10.0845 12.267 9.70583 12.0375L6.60374 10.1575Z",
    fill: "#FFD23C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFillStar);
export default __webpack_public_path__ + "static/media/FillStar.4fb1007dd70387ac75bec600d44aa8ca.svg";
export { ForwardRef as ReactComponent };